import { SidebarGroup } from "@/components/ui/layout/menuSidebar/sidebar"
import { useStripeAccountErrors } from "@/modules/finances/hooks/useStripeAccountErrors"
import {
  Carousel,
  CarouselItem,
  CarouselContent,
  CarouselIndicators,
  CarouselIndicator,
} from "@/components/ui/baseUi/carousel"
import { StripeAccountErrorItem } from "@/modules/finances/components/stripeAccountErrorAlert"
import { PayoutEnumApi } from "@/modules/finances/financesPayout/gateway/payoutApi"
import { useCurrentBox } from "@/modules/box/hooks/useBox"
import { BoxStaffRole } from "@/modules/boxStaff/gateway/boxStaffDto"

export function NavStripe({ className }: { className?: string }) {
  const { result: box } = useCurrentBox()
  const isBoxOwner = box?.currentUserRole === BoxStaffRole.OWNER
  const formattedStripeAccountErrors = useStripeAccountErrors(
    box ? PayoutEnumApi.OWNER : PayoutEnumApi.ATHLETE,
    "sm",
    !box || isBoxOwner,
  )

  if (formattedStripeAccountErrors.length === 0) return null

  return (
    <SidebarGroup className={className}>
      <Carousel className="mx-3 mb-2.5" opts={{ align: "start", loop: true }}>
        <CarouselContent>
          {formattedStripeAccountErrors.map((item, index) => (
            <CarouselItem className="" key={index}>
              <StripeAccountErrorItem
                {...item}
                orientation="vertical"
                primaryButton={item.primaryButton}
                secondaryButton={item.secondaryButton}
                size="S"
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselIndicators>
          {formattedStripeAccountErrors.map((_, index) => (
            <CarouselIndicator key={index} index={index} />
          ))}
        </CarouselIndicators>
      </Carousel>
    </SidebarGroup>
  )
}
